import React, { useContext } from "react";
import { Col, Row } from "antd";
import { FormattedMessage } from "react-intl";
import { CheckOutlined } from "@ant-design/icons";
import styled from "styled-components";
import styles from "src/styles";

// Contexts
import { OffsetLayoutContext } from "src/contexts/layout.context";

// Helpers
import { calculateLayout } from "src/helpers/ui.helper";

// Components
import GhostButton from "src/components/shared/button/GhostButton";

// Assets
import backgroundImage from "src/assets/images/rent_for_company_background.png";

type Props = {
    onClick?: () => void;
};

const RentForCompanyBanner = ({ onClick = () => {} }: Props) => {
    const offsetLayout = useContext(OffsetLayoutContext);
    const layout = calculateLayout(offsetLayout, 24);

    return (
        <DivStyled className="rent-for-company" backgroundImg={backgroundImage}>
            <Row>
                <Col xs={24} md={0} className="images">
                    <img src={backgroundImage} alt="background" />
                </Col>
            </Row>
            <Row className="content">
                <Col {...layout}>
                    <Row>
                        <Col xs={24} md={{ offset: 14, span: 10 }}>
                            <div className="title">
                                <FormattedMessage id="rentForCompanyBanner.title" />
                            </div>
                            <div className="profits">
                                <div className="row">
                                    <div className="column">
                                        <CheckOutlined />
                                    </div>
                                    <div className="column">
                                        <FormattedMessage id="rentForCompanyBanner.profit1" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column">
                                        <CheckOutlined />
                                    </div>
                                    <div className="column">
                                        <FormattedMessage id="rentForCompanyBanner.profit2" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column">
                                        <CheckOutlined />
                                    </div>
                                    <div className="column">
                                        <FormattedMessage id="rentForCompanyBanner.profit3" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column">
                                        <CheckOutlined />
                                    </div>
                                    <div className="column">
                                        <FormattedMessage id="rentForCompanyBanner.profit4" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column">
                                        <CheckOutlined />
                                    </div>
                                    <div className="column">
                                        <FormattedMessage id="rentForCompanyBanner.profit5" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column">
                                        <CheckOutlined />
                                    </div>
                                    <div className="column">
                                        <FormattedMessage id="rentForCompanyBanner.profit6" />
                                    </div>
                                </div>
                            </div>
                            <div className="actions">
                                <GhostButton
                                    className="rent-for-company-button"
                                    onClick={onClick}
                                >
                                    <FormattedMessage id="rentForCompanyBanner.actionButton" />
                                </GhostButton>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </DivStyled>
    );
};

const DivStyled = styled.div<
    React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    > & { backgroundImg: string }
>`
    &.rent-for-company {
        background: url(${(props) => props.backgroundImg});
        background-repeat: no-repeat;
        background-position: left;
        // height: 507px;

        @media screen and (max-width: 767px) {
            background: #112a50;
        }

        .content {
            padding-top: 80px;
            padding-bottom: 40px;
            background: linear-gradient(
                270deg,
                #112a50 45.33%,
                rgba(17, 42, 80, 0) 91.26%
            );
            height: 100%;
            font-style: normal;
            font-weight: 400;
            line-height: 1.6;

            @media screen and (min-width: 1400px) {
                background: linear-gradient(
                    270deg,
                    #112a50 50%,
                    rgba(17, 42, 80, 0) 91.26%
                );
            }

            @media screen and (max-width: 1199px) {
                padding-top: 80px;
            }

            @media screen and (max-width: 992px) {
                padding-top: 60px;
            }
        }

        .images {
            img {
                width: 100%;
                -webkit-mask-image: linear-gradient(
                    180deg,
                    #112a50 55%,
                    rgba(1, 17, 64, 0) 100%
                );
            }
        }

        .title {
            font-size: 31px;
            color: ${styles.fontColorWhite};
            margin-bottom: 20px;

            @media screen and (max-width: 767px) {
                font-size: 24px;
            }
        }

        .profits {
            display: grid;
            row-gap: 14px;

            .row {
                display: grid;
                grid-auto-flow: column;
                column-gap: 15px;
                font-size: 18px;
                color: ${styles.fontColorLightGrayLv2};
                grid-template-columns: 20px auto;

                @media screen and (max-width: 767px) {
                    font-size: 16px;
                }

                .column {
                    .anticon-check {
                        line-height: 1.8;
                    }
                }
            }
        }

        .actions {
            margin-top: 70px;

            @media screen and (max-width: 1199px) {
                margin-top: 50px;
            }

            .rent-for-company-button {
                width: 300px;
                height: 44px;
                font-weight: 600;
                font-size: 20px;

                @media screen and (max-width: 767px) {
                    font-size: 18px;
                }
            }
        }
    }
`;

export default RentForCompanyBanner;
